import React from 'react'
import ContactUsContent from '../../components/contact-us/contact-us'
import LayoutWithOutAccountCard from '../Layout/layout-without-card'

export default function ContactUs() {
 
  return (
    <LayoutWithOutAccountCard breadCumKey='CONTACT_US' showEmptySpace={true} keyPath='CONTACT_US'>
      <div className='new-design-form-style'>
        <ContactUsContent />
      </div>
    </LayoutWithOutAccountCard>
  )
}
